class Batch {
  constructor(batch) {
    this.uid = batch.uid;
    this.channel = batch.channel;
    this.name = batch.name;
    this.slug = batch.slug;
    this.description = batch.description;
    this.isEnrolled = batch.is_enrolled;
    this.thumbnail = batch.cover_photo;
    this.state = batch.state;
    this.startsAt = batch.starts_at;
    this.completedAt = batch.completed_at;
    this.preview = batch.intro_video;
    this.testSeries = batch.test_series_count;
    this.languages = batch.languages;
    this.allTopicsCovered = batch.all_topics_covered;
    this.authors = batch.authors.map((author) => ({ user: author }));
    this.topicGroups = batch.topic_groups
      ? batch.topic_groups.map((topicGroup) => {
          return { topology: topicGroup };
        })
      : null;
    this.goal = batch.goal ? { topology: batch.goal } : null;
  }
}

const getEntityData = (data) => {
  const batch = new Batch(data);
  return batch;
};

const getAuthorsName = (authors) => {
  if (!authors) return '';
  const nameText = authors.slice(0, 3).reduce((initial, educator, index) => {
    if (index === 1) return initial + educator.name;
    if (index < 2 && authors.length === 1) return initial + educator.name;
    if (index < 2) return `${initial} ${educator.name}, `;
    return `${initial} and ${authors.length - 2} more`;
  }, '');
  return nameText;
};

export const getLinkPath = () => '/batch/[slug]/[batchUID]';

export const getLink = (batch) => `/batch/${batch.slug}/${batch.uid}`;

export default {
  Batch,
  getEntityData,
  getAuthorsName,
  getLinkPath,
  getLink
};
